import { createFeedPageController } from '../../external/feed-page/controller';

export default createFeedPageController;
